// src/pages/user/UserDashboard.jsx

import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import API from "../../api";
import { removeAuth } from "../../utils/auth";
import HeroSection from "../../components/HeroSection";

const Container = styled(Box)({
  padding: 16,
  backgroundColor: "#f5f5f5",
  minHeight: "100vh",
});
const Content = styled(Paper)({
  width: "100%",
  maxWidth: 800,
  margin: "0 auto",
  padding: 16,
});

export default function UserDashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const { data } = await API.get("/user/projects");
        setProjects(data);
      } catch (err) {
        console.error(err);
        if (err.response?.status === 401 || err.response?.status === 403) {
          removeAuth();
          navigate("/login", { replace: true });
        }
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [navigate]);

  if (loading) {
    return (
      <Box textAlign="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container>
      <HeroSection sideImages={["/path/to/side1.jpg", "/path/to/side2.jpg"]}>
        <Content sx={{ width: "screen" }}>
          <Typography variant="h5" gutterBottom>
            Your Projects
          </Typography>
          <Table size="small" sx={{ width: "screen" }}>
            <TableHead>
              <TableRow>
                <TableCell>Created At</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Cost (lacs)</TableCell>
                <TableCell>Paid?</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projects.map((p) => (
                <TableRow key={p._id}>
                  <TableCell>
                    {new Date(p.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{p.companyName}</TableCell>
                  <TableCell>{p.projectType}</TableCell>
                  <TableCell>{p.estimatedCost}</TableCell>
                  {/* <TableCell>{p.plan.name}</TableCell> */}
                  <TableCell>{p.isPaid ? "Yes" : "No"}</TableCell>
                  <TableCell align="right">
                    {!p.isPaid && (
                      <Button
                        size="small"
                        onClick={() =>
                          navigate(`/user/create-project/${p._id}`)
                        }
                      >
                        Pay / Edit
                      </Button>
                    )}
                    <Button
                      size="small"
                      sx={{ ml: 1 }}
                      onClick={() =>
                        navigate(`/project-inputs/${p._id}`, {
                          state: { project: p },
                        })
                      }
                    >
                      Start Project
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {projects.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    You have no projects yet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Content>
      </HeroSection>
    </Container>
  );
}
